import React from 'react'
import { useHistory } from 'react-router-dom'
import Avatar from '@material-ui/core/Avatar'
import Box from '@material-ui/core/Box'
import LinkOutlinedIcon from 'components/material-symbol/icons/Link'
import EditOutlinedIcon from 'components/material-symbol/icons/Edit'
import CloseOutlinedIcon from 'components/material-symbol/icons/Close'
import SocialShareDialog from 'components/social-share-dialog'
import { useStyles } from './styles'

const ActionButtons = ({
  setIsOpen,
  bookingType,
  bookingTypeUrl,
  canEdit,
  readOnly = false,
}) => {
  const history = useHistory()
  const classes = useStyles()

  return (
    <Box className={classes.actionButtonContainer}>
      {bookingTypeUrl && !readOnly ? (
        <SocialShareDialog
          trigger={
            <Avatar className={classes.actionAvatar} aria-label="Link">
              <LinkOutlinedIcon color="primary" />
            </Avatar>
          }
          shareUrl={bookingTypeUrl}
          shareTitle={bookingType.title}
          dialogTitle="Share booking link"
          dialogSubtitle="Share this booking type with your students."
          showBookingUrl
          bookingType={bookingType}
          att="pga-lesson-type"
        />
      ) : null}
      {canEdit ? (
        <Avatar
          className={classes.actionAvatar}
          aria-label="Edit"
          onClick={() =>
            history.push(
              `/pga-coach/bookings/booking-types/edit/${bookingType.id}`,
            )
          }
        >
          <EditOutlinedIcon color="primary" />
        </Avatar>
      ) : null}
      <Avatar
        className={classes.actionAvatar}
        aria-label="Close"
        onClick={() => setIsOpen(false)}
      >
        <CloseOutlinedIcon color="primary" />
      </Avatar>
    </Box>
  )
}

export default ActionButtons
